<template>
    <div>
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <div class="pt-4 pb-5 mt-3">
            <b-container>
                <div v-if="informacoes.length">
                    <b-row>
                        <b-col cols="12" md="4" class="mb-4" v-for="info in informacoes" :key="info.id">
                            <div class="contact-info-title mb-3"> {{ info.name1 }} </div>
                            <div>
                                <div class="contact-info-text" v-html="info.text1"></div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <b-row>
                    <b-col cols="12">
                        <FormContact/>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
</template>
<script>
import utils from '~/mixins/utils'
import Breadcrumb from '~/components/Breadcrumb';
import FormContact from '~/components/FormContact';
export default {
    head() {
        return {
            title: 'Contato',
        }
    },
    mixins: [
        utils
    ],
    components:{
        Breadcrumb,
        FormContact
    },
    computed: {
        breadcrumb() {
            let breadcrumb = [
                {
                    name: 'Home',
                    link: '/'
                }
            ];
            breadcrumb.push({
                name: 'Contato',
                link: null
            });
            return breadcrumb;
        },
    },
    async asyncData({params, query, res, $axios, req, app, error, store}) {
        try {
            let informacoes = {}
            await $axios.$get(`/api/v1/cms/?page_id=10&categories_content=true`).then((res) => {
                if (res.status === 'success') {
                    informacoes = res.data
                }
            })
            return {
                informacoes: informacoes,
            }
        } catch (e) {
            console.log(e)
        }
    }
}
</script>
